import React from 'react'
import Img from 'gatsby-image'
import carImage from '../images/leasing/car.jpg'
import Helmet from 'react-helmet'


const CorporateProgramEn = () => (
  <div className="page corporate_program" >

  <Helmet
          title={`Nicaragua Corporate Program with Budget Nicaragua`}
          meta={[
            {
              name: 'description',
              content:
                'Frequently Asked Questions about car rentals.',
            },
          ]}
          link={[
            {
              rel: 'alternate',
              hreflang: 'en',
              href: './es/corporate_program',
            },
          ]}
        />
    <div className="image"></div>
    <h1>Corporate Program</h1>
    
    <h2>We have the vehicle that fits to your business needs</h2>
    <h3>Our corporate program offers affiliates exclusive benefits:</h3>
    <div >
      <div>  
        <ul>
          <li>
          Special Rates
          </li>
          <li>
          Corporate Credit
          </li>
          <li>
          Personalized attention with an executive dedicated to your account
          </li>
          <li>
          Personalized attention
          </li>
          <li>
          Immediate credit approval
          </li>
          <li>
          Fixed rates throughout the year
          </li>
          <li>
          Drop of service at no additional cost (restrictions apply)
          </li>
          <li>
          Additional driver at no cost.
          </li>
          <li>
          Airport charge exemption.
          </li>
          <li>
          Monthly rental program (restrictions apply)
          </li>
          <li>
          Discounts for your employees.
          </li>
          
        </ul>

        <p>
        The best option for your company!<br/>
        Contact us to obtain the best transport solution for your company,with the quality, service and trust that only Budget can offer you.
        </p>
        
        <div>  
        <a href="mailto:negocios@budget.com.ni" className="btn">
          Contact Us
        </a>
      </div>
      </div>
    </div>
    
  </div>
)
export default CorporateProgramEn






// WEBPACK FOOTER //
// ./src/pages/corporate_program.en.js